import { getCookie, setCookie } from '../storage/cookies';
import { md5 } from '../lib/md5';
import amaLog from '../helpers/log';

const PPID_COOKIE = 'aapp';

let _ppid: string | undefined = undefined;
/**
 * Retrieves The Publisher provided identifier (PPID)
 * from the cookie(The current source for PPID
 * is a random first-party cookie created called 'aapp',
 * previously tealium cookies were used) or
 * generates a new one if not present.
 * If the PPID is invalid, it returns undefined.
 *
 * @returns {string|undefined} - The PPID or undefined if invalid.
 */
export const getPPID = (): string | undefined => {
  if (_ppid) {
    amaLog('Cached ppid:', typeof _ppid, _ppid);
    return _ppid;
  }

  try {
    // Check if PPID exists for norway. This will only be needed for max a year after release.
    const noPPID = getCookie('ppid');
    if (noPPID) {
      _ppid = noPPID;
      amaLog('ppid norwegian temp set: ', typeof _ppid, _ppid);
    } else {
      const ppIdCookie = noPPID || getCookie(PPID_COOKIE) || getNewPpid();

      const ppIdHashed = md5(`${ppIdCookie}`);

      amaLog('ppIdCookie hash: ', typeof ppIdCookie, ppIdCookie, typeof ppIdHashed, ppIdHashed);

      _ppid = isValidPpid(ppIdHashed) ? ppIdHashed : undefined;
    }

    return _ppid;
  } catch (e) {
    console.warn(`PPID: Failed to hash user identifier`);
  }
};

/**
 * Checks if a value is a valid hashed PPID.
 *
 * @param {string} val - The value to check.
 * @returns {boolean} - True if the value is a valid string, false otherwise.
 */
const isValidPpid = (val: string): boolean => typeof val === 'string' && val.length >= 32 && val.length <= 150;

/**
 * Generates a new PPID, sets it in the cookie, and returns the generated PPID.
 *
 * @returns {string} - The newly generated PPID.
 */
const getNewPpid = (): string => {
  const id = Date.now() + ('' + Math.floor(100000000 + Math.random() * 10000000)).substring(1);
  setCookie(PPID_COOKIE, id, 400, 'high');
  return id;
};

const ppid = {
  get: getPPID,
  isValidPPID: isValidPpid,
};

export default ppid;
